import CashRow from '../CashRow'
import {currencyFormatter, rupiahWithNegative} from 'utils/formatter'
class ShiftDetailOther extends React.Component {
  render () {
    let {shift} = this.props
    return (<div className='row'>
      <div className='col-lg-12'>
        <div className='form-group col-sm-12 label-section'>
          <label>Other</label>
        </div>
        <div className='col-sm-12 other_detail no-padding-right'>
          <CashRow label='EDC' value={currencyFormatter(shift.total_edc)} />
          <CashRow label='Gift Card' value={currencyFormatter(shift.total_gift_card)} />
          <CashRow label='Other' value={currencyFormatter(shift.total_other)} />
          <CashRow label='Refunds' value={rupiahWithNegative(`-${shift.other_refunds}`)} />
          <CashRow label='Expected Other Payment' value={currencyFormatter(shift.expected_other_payment)} />
        </div>
      </div>
    </div>)
  }
}

ShiftDetailOther.propTypes = {
  shift: React.PropTypes.object
}

export default ShiftDetailOther



// WEBPACK FOOTER //
// ./app/pages/Reports/Shift/ShiftDetail/ShiftDetailModal/ShiftDetailOther/ShiftDetailOther.js